import UserMessageItem from './UserMessageItem'

export default UserMessageItem
